import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { polyfill } from 'react-lifecycles-compat';
import classnames from 'classnames';
import DateCell from './DateCell';
import CONST from './const';
import Icon from '../Icon';

var MonthPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(MonthPanel, _React$Component);

  var _super = _createSuper(MonthPanel);

  function MonthPanel() {
    var _this;

    _classCallCheck(this, MonthPanel);

    _this = _super.apply(this, arguments);
    _this.state = {
      startDate: _this.props.startDate,
      selectDate: _this.props.selectDate
    };

    _this.selectMonth = function (timestamp, evt) {
      evt.stopPropagation();

      _this.props.onSelectMonth(timestamp, 'date', evt);
    };

    _this.preYear = function (evt) {
      evt.stopPropagation();

      _this.props.handleChangeDate('subtract', 'year');
    };

    _this.nextYear = function (evt) {
      evt.stopPropagation();

      _this.props.handleChangeDate('add', 'year');
    };

    _this.showYear = function (evt) {
      evt.stopPropagation();

      _this.props.onShowPanel('year');
    };

    _this.renderMonthPanel = function () {
      var html = [];
      var monthNodeArr = [];
      var monthArr = [];
      var monthClass = '';
      var _this$state = _this.state,
          startDate = _this$state.startDate,
          selectDate = _this$state.selectDate;
      var _this$props = _this.props,
          disabledDate = _this$props.disabledDate,
          dateCellRender = _this$props.dateCellRender,
          dateType = _this$props.dateType;
      var today = dayjs();
      CONST.MONTH.forEach(function (month, index) {
        monthArr.push({
          monthTxt: month,
          monNum: index
        });

        if ((index + 1) % 4 === 0) {
          monthNodeArr = monthArr.map(function (_m) {
            var monthTxt = _m.monthTxt,
                monNum = _m.monNum;
            var disabled = dateType === 'month' ? disabledDate(startDate.set('month', monNum).set('date', 1)) : false;
            monthClass = classnames({
              month: true,
              today: monNum === today.month() && startDate.year() === today.year(),
              active: monNum === selectDate.month() && startDate.year() === (selectDate && selectDate.year()),
              disabled: disabled
            });
            return /*#__PURE__*/React.createElement(DateCell, {
              key: "".concat(monthTxt),
              className: monthClass,
              date: startDate.set('month', monNum),
              onSelectDate: _this.selectMonth,
              dateText: monthTxt,
              disabled: disabled,
              dateCellRender: dateCellRender
            });
          });
          html.push( /*#__PURE__*/React.createElement("tr", {
            key: "".concat(startDate.year()).concat(index)
          }, monthNodeArr));
          monthArr = [];
        }
      });
      return html;
    };

    return _this;
  }

  _createClass(MonthPanel, [{
    key: "render",
    value: function render() {
      var startDate = this.state.startDate;
      var show = this.props.show;
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-datepicker-months",
        style: {
          display: "".concat(show ? 'block' : 'none')
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-datepicker-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-pre"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "chevron-left",
        size: "18px",
        onClick: this.preYear
      })), /*#__PURE__*/React.createElement("div", {
        className: "action-select"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: this.showYear
      }, startDate.year())), /*#__PURE__*/React.createElement("div", {
        className: "action-next"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "chevron-right",
        size: "18px",
        onClick: this.nextYear
      })))), /*#__PURE__*/React.createElement("div", {
        className: "roo-datepicker-body"
      }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, this.renderMonthPanel()))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.startDate.valueOf() !== state.startDate.valueOf()) {
        return {
          startDate: nextProps.startDate,
          selectDate: nextProps.selectDate
        };
      }

      return {};
    }
  }]);

  return MonthPanel;
}(React.Component);

MonthPanel.defaultProps = {
  show: false,
  startDate: dayjs(),
  selectDate: dayjs(),
  disabledDate: function disabledDate() {
    return false;
  },
  onShowPanel: function onShowPanel() {},
  onSelectMonth: function onSelectMonth() {},
  handleChangeDate: function handleChangeDate() {}
};
MonthPanel.propTypes = {
  show: PropTypes.bool,
  startDate: PropTypes.object,
  selectDate: PropTypes.object,
  disabledDate: PropTypes.func,
  onShowPanel: PropTypes.func,
  onSelectMonth: PropTypes.func,
  handleChangeDate: PropTypes.func
};
polyfill(MonthPanel);
export default MonthPanel;